import React from "react";

/**
 * DraftBanner — restrained document-status marker on all /legal/* pages
 * while templates are pending outside counsel review. Sits inline above
 * the page eyebrow. Navy strip with gold hairlines and tracked type.
 *
 * DRAFT — PENDING LEGAL REVIEW
 */
export const DraftBanner = () => {
  return (
    <div
      role="note"
      aria-label="Document status"
      data-testid="legal-draft-banner"
      className="inline-flex items-center gap-3 border border-gold/50 bg-[var(--q-bg-dark)] text-gold px-4 py-2"
    >
      <span aria-hidden="true" className="inline-block h-px w-4 bg-gold" />
      <span
        className="font-sans uppercase"
        style={{ fontSize: "10.5px", letterSpacing: "0.22em" }}
      >
        Draft &middot; Pending Legal Review
      </span>
      <span aria-hidden="true" className="inline-block h-px w-4 bg-gold" />
    </div>
  );
};

export default DraftBanner;
